<script setup>
import { computed, getCurrentInstance, onMounted, ref } from 'vue'

const props = defineProps({
    itemId: {
        type: String,
        required: true,
    },
})

const { proxy } = getCurrentInstance()
const item = ref(null)
const failed = ref(false)
const price = computed(() => {
    if (!item.value) return '—'
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: item.value.currency,
    }).format(Number(item.value.price))
})

onMounted(async () => {
    try {
        const result = await proxy.$api({
            serviceName: 'stripeCheckout',
            methodName: 'getItem',
            parameters: [props.itemId],
        })
        if (!result?.error) item.value = result
        else failed.value = true
    } catch (exception) {
        console.error('Could not load payment item:', exception)
        failed.value = true
    }
})
</script>

<template><span class="payment-price" :class="{ loading: !item && !failed, failed }">{{ failed ? '—' : price }}</span></template>

<style scoped>
.payment-price { display: inline-flex; align-items: center; min-height: 1em; color: var(--accent-gold); font-variant-numeric: tabular-nums; }
.payment-price.loading { width: 4ch; border-radius: 4px; background: var(--glass-strong); color: transparent; animation: price-pulse 1.2s ease-in-out infinite; }
.payment-price.failed { color: var(--status-danger); font-size: .78rem; }
@keyframes price-pulse { 50% { opacity: .45; } }
</style>
